import React from 'react';
import { Box, Collapse, Alert, AlertTitle, Typography, Button, Tabs, Tab } from '@mui/material';
import QRCodeCard from '../shared/QRCodeCard';

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box pt={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

interface SetupResultProps {
    isSetupSuccessful: boolean;
    displayUrl: string;
    onGoBack: () => void;
}

const SetupResult: React.FC<SetupResultProps> = ({ isSetupSuccessful, displayUrl, onGoBack }) => {

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    return (
        <>
            {isSetupSuccessful ? (
                <Box display={'flex'} flexDirection={"column"} justifyContent="space-around" gap={2}>
                    <Alert severity="success">
                        <AlertTitle>EDisplay erfolgreich eingerichtet!</AlertTitle>
                        Klicken Sie auf 'E-Display öffnen', um die Seite direkt auf diesem Gerät zu laden. Alternativ können Sie den QR-Code scannen, um die Seite auf einem anderen Tablet zu öffnen.
                    </Alert>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange}>
                            <Tab label="E-Display" />
                            <Tab label="Einrichtung" />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <QRCodeCard value={displayUrl.prependBaseUrl()}>
                            <Box display="flex"
                                mt={2}
                                flexDirection="column"
                                height="100%"
                                sx={{ textTransform: "uppercase", fontSize: 20, fontWeight: "bold" }}
                            >
                                <Typography color="textSecondary" sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
                                    QRCode
                                </Typography>
                                <Typography color="textPrimary" ml={1} sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
                                    E-Display
                                </Typography>
                            </Box >
                        </QRCodeCard>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <QRCodeCard value={displayUrl.prependBaseUrl().pointToSetup()}>
                            <Box display="flex"
                                mt={2}
                                flexDirection="column"
                                height="100%"
                                sx={{ textTransform: "uppercase", fontSize: 20, fontWeight: "bold" }}
                            >
                                <Typography color="textSecondary" sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
                                    QRCode
                                </Typography>
                                <Typography color="textPrimary" ml={1} sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
                                    Einrichtung
                                </Typography>
                            </Box >
                        </QRCodeCard>
                    </CustomTabPanel>

                </Box>
            ) : (
                <>
                    <Alert severity="error">
                        <AlertTitle>Einrichtung fehlgeschlagen</AlertTitle>
                        Die Konfiguration konnte nicht abgeschlossen werden. Bitte überprüfen Sie die Eingaben für die Tenant-ID und den Gerätenamen und versuchen Sie es erneut.
                    </Alert>
                    <Button onClick={onGoBack} color='error'>Zurück</Button>
                </>
            )}
        </>
    );
};

export default SetupResult;
